import React, { useEffect, useState, useReducer, useRef } from "react";
import ic_cubix_ribbon_logo from "../img/ic_cubix_ribbon_label.png";
import ic_blue_cube from "../img/ic_blue_cube.png";
import ic_search from "../img/ic_search.png";
import "../css/MakeOrderPage.css";
import Header from "./Header";
import ic_continue_arrow from "../img/ic_continue_arrow.png"
import MakeOrderPageListContainer from "./MakeOrderPageListContainer";
import ConfirmSalesOrderPopup from "./ConfirmSalesOrderPopup";
import axios from "axios";
import OurBarcodeComponent from "./OurBarcodeComponent";

function MakeOrderPage() {

    const[currentResultOfBarcode, setCurrentResultOfBarcode] = useState(null)

    // const [idOfRowInListOfScanBarcode, setIdOfRowInListOfScanBarcode] = useState(null)

    const idOfRowInListOfScanBarcode = useRef(null)

    const [showBarcodeScannerView, setShowBarcodeScannerView] = useState(false)

    useEffect(() => {

        console.log("showBarcodeScannerView", showBarcodeScannerView)

    }, [showBarcodeScannerView])

    const toggleBarcodeScannerView = (idOfRowInList) => {
        setShowBarcodeScannerView(prev => !prev)
       //setIdOfRowInListOfScanBarcode(idOfRowInList)
        idOfRowInListOfScanBarcode.current = idOfRowInList
        
    }

    const [errorMessage, setErrorMessage] = useState("");
    const [isCallingApi, setIsCallingApi] = useState(false);
    const [itemCodeIsEmptyPopup, setItemCodeIsEmptyPopup] = useState(false);
    const [quantityIsEmptyPopup, setQuantityIsEmptyPopup] = useState(false);
    const [orderSendState, setOrderSendState] = useState(false);

    const clearCurrentFormFromLocalStorage = () => {
        console.log("inside MakeOrderPage clearCurrentFormFromLocalStorage func");
        localStorage.removeItem("cubix_order_taking_currentOrder");

        setCurrentOrderObjectState({ company_name: "" });
        setCurrentOrderObjectState({ company_account_number: "" });
        setCurrentOrderObjectState({ company_address_1: "" });
        setCurrentOrderObjectState({ company_address_2: "" });
        setCurrentOrderObjectState({ company_address_3: "" });
        setCurrentOrderObjectState({ company_phone: "" });
        setCurrentOrderObjectState({ account: "" });
        setCurrentOrderObjectState({ balance: "" });
        setCurrentOrderObjectState({ credit_method: "" });
        setCurrentOrderObjectState({ OrderRemark: "" });

        setCurrentOrderObjectState({ order_items_array: [] });
    }
    const [deleteFromLocalStorageState, setDeleteFromLocalStorageState] = useState(false);

    const showHideDeleteDataPopup = () => {
        setDeleteFromLocalStorageState(prev => !prev);
    }
    const deleteFromLocalStorageConfirmed = () => {
        clearCurrentFormFromLocalStorage();
        showHideDeleteDataPopup();
    }
    const [customerEmptyPopupState, setCustomerEmptyPopupState] = useState(false);
    const searchBoxRef = useRef(null);
    let timeInterval = null;
    const [showHideSearchListBox, setShowHideSearchListBox] = useState(false);
    const initialCurrentOrderObject = {
        sales_order_created_from: "website",
        company_name: "",
        company_account_number: "",
        company_address_1: "",
        company_address_2: "",
        company_address_3: "",
        company_phone: "",
        account: "",
        balance: "",
        credit_method: "",
        OrderRemark: "",
        debit: 0,
        credit: 0,
        order_items_array: []
    }

    const [currentOrderObjectState, setCurrentOrderObjectState] = useReducer(
        (currentOrderObjectState, updates) => ({ ...currentOrderObjectState, ...updates }),
        initialCurrentOrderObject);

    let table_row_object_template = {
        id: currentOrderObjectState.order_items_array.length + 1,
        item_name: "",
        item_qty: "",
        item_code: "",
        item_price: "",
        item_unit: "",
        itemwiseRemark: "",
        BarcodeRemark: "",
        item_unit_price_static: "",
    }

    const [clickedOnContinueButton, setClickedOnContinueButton] = useState(false);
    const [arrayOfSearchResults, setArrayOfSearchResults] = useState();


    const showHideItemCodeIsEmptyPopup = () => {
        setItemCodeIsEmptyPopup(prev => !prev);
    }

    const showHideQuantityIsEmptyPopup = () => {
        setQuantityIsEmptyPopup(prev => !prev);
    }

    const showHideCustomerEmptyPopup = () => {
        setCustomerEmptyPopupState(prev => !prev);
    }
    const changeStatusOfClickedOnContinueButton = () => {
        console.log("clicked changeStatusOfClickedOnContinueButton")

        if (currentOrderObjectState.company_account_number.length > 0) {

            // if quantity or item name is empty ie (item code should not be empty, ie item should be selected from the search list 
            // ie if user hasn't selected an item we cannot set item code)
            // if either of it is empty in any of the item ,
            // show popup saying [item is not selected from search list]
            // or [item quantity is not entered ] 
            // first check if item quantity is empty in every item
            // then on second step check if item code is empty

            let emptyItemArray = currentOrderObjectState.order_items_array.filter((item) => {
                return item.item_qty == "" || item.item_qty == null || item.item_qty <= 0;
            });

            console.log("emptyItemArray is ", emptyItemArray);

            if (emptyItemArray.length > 0) {
                showHideQuantityIsEmptyPopup();
            } else {
                // every Item's quantity is entered now check for item code
                let emptyItemArray = currentOrderObjectState.order_items_array.filter((item) => {
                    return item.item_code == "" || item.item_code == null || item.item_code == 0 || item.item_code == "no item code";
                });
                console.log("emptyItemArray is ", emptyItemArray);

                if (emptyItemArray.length > 0) {
                    showHideItemCodeIsEmptyPopup();
                } else {
                    setClickedOnContinueButton(prev => !prev);
                }
            }


        } else {
            showHideCustomerEmptyPopup();
        }

    }

    const showHideSalesOrderPopup = (sendOrderStatusText) => {
        setClickedOnContinueButton(prev => !prev);

        if (sendOrderStatusText == "order_send") {
            setOrderSendState(true);
        }
    }

    const addTableRow = () => {
        setCurrentOrderObjectState({ order_items_array: [...currentOrderObjectState.order_items_array, table_row_object_template] })
    };

    useEffect(() => {

        // first check whether is there any data in localstorage for current order
        // if yes call getCurrentOrderFromLocalStorage

        if (localStorage.getItem("cubix_order_taking_currentOrder") != null) {

            const currentOrderFromLocalStorage = localStorage.getItem("cubix_order_taking_currentOrder");
            if (currentOrderFromLocalStorage.length == 0) {
                console.log("local storage key present but length 0");
            } else {
                setCurrentOrderObjectState(JSON.parse(currentOrderFromLocalStorage));
                console.log("from local storage", currentOrderFromLocalStorage);
            }


        } else {
            console.log("no cubix_order_taking_currentOrder in local storage");
            addTableRow();
        }

    }, [])

    const handleInput = (e) => {

        clearInterval(timeInterval);

        timeInterval = setTimeout(() => {
            if (e.target.value.length > 0) {

                console.log(" searchtext changed is", e.target.value);
                if (timeInterval) {
                    console.log("timer is not null we are clearing it")
                    clearInterval(timeInterval);
                }
                setShowHideSearchListBox(true);
                setIsCallingApi(true);
                callApi(e.target.value);

            } else {
                setShowHideSearchListBox(false);
            }
        }, 500)
    }

    const callApi = (searchingText) => {
        let sales_man_name = localStorage.getItem("cubix_order_taking_sales_man");

        let userGroup = localStorage.getItem("cubix_order_taking_logged_in_person_group");

        if (userGroup != null) {

            console.log("userGroup is ", userGroup);

            if (userGroup.trim() == "ADMIN" || userGroup.trim() == "VIEW" || userGroup.trim() == "acntsentry" || userGroup.trim() == "SALES" || userGroup.trim() == "EX_SALES") {

                axios.get(`${process.env.REACT_APP_BASE_URL}/Search_Customer/Cust/${searchingText}`).then((res) => {

                    setIsCallingApi(false);

                    console.log(" res is ", res);
                    setArrayOfSearchResults(res.data.jsont);
                }).catch(err => console.log("error is ", err))

            } else {

                axios.get(`${process.env.REACT_APP_BASE_URL}/SearchCust_Sales/customer/${searchingText}/${sales_man_name}`).then((res) => {

                    setIsCallingApi(false);

                    console.log(" res is ", res);
                    setArrayOfSearchResults(res.data);
                }).catch(err => console.log("error is ", err))

            }
        } else {
            setTimeout(() => {
                setErrorMessage("");
            }, 3000)
            setErrorMessage("User group is null, cannot get customer list");
        }
    }

    const clickedItemFromSearchList = (ind) => {
        console.log("clicked on ", ind);

        searchBoxRef.current.value = "";

        if (arrayOfSearchResults != null) {

            setCurrentOrderObjectState({ company_name: arrayOfSearchResults[ind].Custname });
            setCurrentOrderObjectState({ company_account_number: arrayOfSearchResults[ind].account });
            setCurrentOrderObjectState({ company_address_1: arrayOfSearchResults[ind].address1 });
            setCurrentOrderObjectState({ company_address_2: arrayOfSearchResults[ind].address2 });
            setCurrentOrderObjectState({ company_address_3: arrayOfSearchResults[ind].address3 });
            setCurrentOrderObjectState({ company_phone: arrayOfSearchResults[ind].phone });
            setCurrentOrderObjectState({ account: arrayOfSearchResults[ind].account });
            setCurrentOrderObjectState({ balance: arrayOfSearchResults[ind].openbal });
            setCurrentOrderObjectState({ credit_method: arrayOfSearchResults[ind].CREDITMETHOD })
            setCurrentOrderObjectState({ debit: arrayOfSearchResults[ind].debit })
            setCurrentOrderObjectState({ credit: arrayOfSearchResults[ind].credit })

        }

        setShowHideSearchListBox(false);
    }

    const sendClickedRowIteObjectToParent = (idOfSearchBoxParent, objectFromChild) => {

        console.log("object from child", objectFromChild);

        let updatedTableRows = currentOrderObjectState.order_items_array.map((item) => {
            console.log("item id  is ", item.id);
            console.log("idOfSearchBoxParent is ", idOfSearchBoxParent);
            console.log("objectFromChild is ", objectFromChild);

            if (item.id == idOfSearchBoxParent) {
                return {
                    ...item,
                    item_name: objectFromChild.item_name,
                    item_price: objectFromChild.item_price,
                    item_code: objectFromChild.item_code,
                    item_qty: objectFromChild.item_qty,
                    item_unit: objectFromChild.item_unit,
                    itemwiseRemark: objectFromChild.itemwiseRemark,
                    BarcodeRemark: objectFromChild.BarcodeRemark,
                    item_unit_price_static: objectFromChild.item_unit_price_static,
                }

            } else {
                return item;
            }
        })

        console.log("object from child after updating qty", updatedTableRows);
        setCurrentOrderObjectState({ order_items_array: updatedTableRows });

    }

    const sendClickedRowIteObjectToParentLastCustomerPrice = (objectFromChild) => {

        console.log("object from child last customer price ", objectFromChild);

        let updatedTableRows = currentOrderObjectState.order_items_array.map((item) => {
            console.log("object from child last customer price ", objectFromChild);

            if (item.item_code == objectFromChild.item_code) {
                return {
                    ...item,
                    item_price: objectFromChild.last_price,
                }
                // console.log("match found is ", item.item_code);

            } else {
                return item;
                //console.log("no match found is ");
            }
        })

        console.log("object from child after last customer price ", updatedTableRows);
        setCurrentOrderObjectState({ order_items_array: updatedTableRows });

    }

    const deleteItemFromParent = (idOfChildRow) => {

        console.log("inside deleteItemFromParent idOfChildRow is ", idOfChildRow);
        let i = 1;
        let updatedTableRowsAfterDeletion = currentOrderObjectState.order_items_array.filter((item, index) => {

            if (item.id != idOfChildRow) {
                console.log("item.id != idOfChildRow ", item.id, idOfChildRow);
                return item;
            }

        })

        let updatedTableRowsAfterDeletionAndNewId = updatedTableRowsAfterDeletion.map((item, index) => {
            console.log("new index after mapping is", index);

            return {
                ...item,
                id: index + 1
            }
        })

        console.log("updatedTableRowsAfterDeletionAndNewId ", updatedTableRowsAfterDeletionAndNewId);

        setCurrentOrderObjectState({ order_items_array: updatedTableRowsAfterDeletionAndNewId });

        //console.log("going to reset localstorage after deletion", {...currentOrderObjectState,order_items_array: updatedTableRowsAfterDeletionAndNewId });

        // explicitly no need to remove from local storage here because
        // everytime order_item array is changed MakeOrderPageListContainer has  localStorage.setItem that sets new value

        // but one issue if we are going to delete if there is only a single item we delete it and
        // we reresh it again that item appears again because everytime order_array_changes 
        // it checks if size is greater than zero 
        // then only local storage is written so in the case when there is only one item we delete it
        // then this condition will not pass

        // so in that case set template item but one is that since any other state change it will again set to empty values

        // so if the array length is 1 and we are going to delete it save the customer name to local storag here 
        // TODO
        // if size of updatedTableRowsAfterDeletion is zero set template object to localStorage.setItem("cubix_order_taking_currentOrder", JSON.stringify({...fullObject, order_items_array:[template object here]}));


    }

    const handleInputOrderRemark = (e) => {
        console.log("input inside handleInputOrderRemark", e.target.value);

        setCurrentOrderObjectState({ OrderRemark: e.target.value })
    }

    const resultGotAfterBarcodeScan = (result ) => {

        console.log("result of barcode scan and row",result, idOfRowInListOfScanBarcode.current)

        setCurrentResultOfBarcode(result)
        
    }




    return (
        <div className="MakeOrderPage-root-container">

            <div className="MakeOrderPage-layer-1">
                <img src={ic_blue_cube} />
            </div>

            <div className="MakeOrderPage-layer-2 ">
                <Header />

                <div className="MakeOrderPage-layer-2-top">
                    <h4>Make Order</h4>
                    <span>
                        <button onClick={showHideDeleteDataPopup}>Delete All Data</button>
                    </span>
                </div>
                <div className="MakeOrderPage-layer-2-underline"></div>

                <div className="MakeOrderPage-search-box-and-list-container">

                    {
                        errorMessage != null ?
                            errorMessage.length > 0 && <div className="MakeOrder-errorMessageContainer">
                                <p>
                                    {errorMessage}
                                </p>
                            </div>
                            :
                            null
                    }

                    <div className="MakeOrderPage-search-box">
                        <div>
                            <img src={ic_search} />
                        </div>
                        <input autoComplete="off" ref={searchBoxRef} className="MakeOrderPage-search-input" type="text" placeholder="Enter customer name" onChange={(e) => handleInput(e)} />
                    </div>


                    {showHideSearchListBox &&

                        <div className="CustomerDetailsPage_SearchResultListContainer">

                            {isCallingApi && <div className="MakeOrderPage-searching-for-company-div"><span>Searching for item ...</span></div>}

                            <table className="CheckStockPage_SearchResultListContainer-table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Account Number</th>
                                        <th>Balance</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {arrayOfSearchResults != null ?
                                        arrayOfSearchResults.length > 0 ?
                                            arrayOfSearchResults.map((item, index) => {
                                                return (<tr key={item.Code} id={item.Code} className="CheckStockPage_SearchResultListContainer_single_list_item" onClick={() => clickedItemFromSearchList(index)} >
                                                    <td>
                                                        <div>
                                                            {item.Custname}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>
                                                            {item.account}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>
                                                            {(item.debit - item.credit).toLocaleString('en-US', { maximumFractionDigits: 2 })}
                                                        </div>
                                                    </td>

                                                    {/* currently no status is received from API, when we receive
                                                    the value put it in this column */}


                                                    {/* <td>
                                                        <div>
                                                            {item.status}
                                                        </div>
                                                    </td> */}

                                                </tr>)
                                            })
                                            : null
                                        : null}

                                </tbody>
                            </table>
                        </div>
                    }
                </div>

                <div className="MakeOrderPage-result-container mt-4">
                    <div className="MakeOrderPage-result-container-label">
                        <span className="MakeOrder-heading-label">Selected Customer</span>
                        <button onClick={changeStatusOfClickedOnContinueButton}>Continue <img src={ic_continue_arrow} className="ms-1" /></button>
                    </div>
                    <div className="MakeOrderPage-result-container-name-value mt-2">
                        {currentOrderObjectState.company_name}
                    </div>

                    <div className="MakeOrderPage-result-container-address-value mt-1">

                        <span>{currentOrderObjectState.company_address_1}</span>
                        <span>{currentOrderObjectState.company_address_2}</span>
                        <span>{currentOrderObjectState.company_address_3}</span>
                        <span>{currentOrderObjectState.company_phone}</span>
                    </div>

                    <div className="mt-4">
                        <span className="MakeOrder-heading-label">Account Number</span>
                        <div className="MakeOrderPage-result-container-name-value mt-2">
                            {currentOrderObjectState.account}
                        </div>
                    </div>

                    <div className="mt-4">
                        <span className="MakeOrder-heading-label">Balance</span>
                        <div className="MakeOrderPage-result-container-name-value mt-2">
                            {console.log("currentOrderObjectState >> ", currentOrderObjectState.debit)}
                            {(currentOrderObjectState.debit - currentOrderObjectState.credit).toLocaleString('en-US', { maximumFractionDigits: 2 })}
                        </div>
                    </div>

                    <div className="mt-4">
                        <span className="MakeOrder-heading-label">Status</span>
                        <div className="MakeOrderPage-result-container-name-value mt-2">
                            {
                                currentOrderObjectState != null ?
                                    currentOrderObjectState.credit_method
                                    : null
                            }
                        </div>
                    </div>

                    <div className="MakeOrderPage-Order-Remake-container mt-4">
                        <label>Order Remark</label>
                        <input className="MakeOrder-OrderRemark-input" value={currentOrderObjectState.OrderRemark} onChange={(e) => handleInputOrderRemark(e)} />
                    </div>

                    {
                        currentOrderObjectState != null ?
                            currentOrderObjectState.credit_method != "BLOCKED" ?
                                <div className="MakeOrderPage-if-not-blocked-then-show-this-div">
                                    <MakeOrderPageListContainer
                                        fullObject={currentOrderObjectState}
                                        sendClickedRowIteObjectToParent={sendClickedRowIteObjectToParent}
                                        sendClickedRowIteObjectToParentLastCustomerPrice={sendClickedRowIteObjectToParentLastCustomerPrice}
                                        deleteItemFromParent={deleteItemFromParent}
                                        toggleBarcodeScannerView={toggleBarcodeScannerView} 
                                        currentResultOfBarcode ={currentResultOfBarcode}
                                        idOfRowInListOfScanBarcode = {idOfRowInListOfScanBarcode}
                                        />

                                    <div className="MakeOrderPage-total-container">
                                        <span className="me-4">Total </span>

                                        <label className="MakeOrderPage-total-container-label-value"> {currentOrderObjectState.order_items_array.reduce((acc, curr) => {

                                            return acc = acc + Math.round((curr.item_price * curr.item_qty) * 100) / 100

                                        }, 0).toLocaleString('en-US', { maximumFractionDigits: 2 })}
                                        </label>
                                    </div>

                                    <div className="mt-2">
                                        <span className="MakeOrderPage-add-item-button" onClick={addTableRow}>+ Add item</span>
                                    </div>
                                </div>
                                :
                                <div className="MakeOrderPage-cannot-take-order-div mt-3">
                                    BLOCKED : Cannot take order
                                </div>
                            :
                            null
                    }

                </div>


            </div>

            {clickedOnContinueButton &&
                <ConfirmSalesOrderPopup changeStatusOfClickedOnContinueButton={changeStatusOfClickedOnContinueButton} showHideSalesOrderPopup={showHideSalesOrderPopup} salesOrderObjectToSend={currentOrderObjectState} clearCurrentFormFromLocalStorage={clearCurrentFormFromLocalStorage} />
            }

            {
                customerEmptyPopupState &&
                <div className="MakeOrder-CustomerEmpty-Popup-root-container">

                    <div className="MakeOrder-CustomerEmpty-Popup-root-container-child card">
                        <h4>Please Enter Customer name</h4>
                        <div>
                            Enter customer name in the search box and select a customer.
                        </div>
                        <div className="MakeOrder-CustomerEmpty-Popup-child-button-container mt-4">
                            <button onClick={showHideCustomerEmptyPopup}>OK</button>

                        </div>
                    </div>
                </div>
            }

            {deleteFromLocalStorageState &&
                <div className="DeleteFromLocalStorage-Popup-root-container ">

                    <div className="DeleteFromLocalStorage-Popup-root-container-child card">
                        <h4>Delete All Data </h4>
                        <div>
                            Current customer details and items will be deleted
                        </div>
                        <div className="DeleteFromLocalStorage-Popup-child-button-container mt-4">
                            <span>
                                <button onClick={showHideDeleteDataPopup}>Cancel</button>
                            </span>
                            <span>
                                <button onClick={deleteFromLocalStorageConfirmed} className="DeleteFromLocalStorage-delete-data">Delete Data</button>
                            </span>
                        </div>
                    </div>
                </div>
            }
            {
                orderSendState &&
                <div className="MakeOrder-CustomerEmpty-Popup-root-container">

                    <div className="MakeOrder-CustomerEmpty-Popup-root-container-child card">
                        <h4>Success</h4>
                        <div>
                            Order has been send.
                        </div>
                        <div className="MakeOrder-CustomerEmpty-Popup-child-button-container mt-4">
                            <button onClick={() => setOrderSendState(false)}>OK</button>

                        </div>
                    </div>
                </div>
            }

            {
                quantityIsEmptyPopup &&

                <div className="MakeOrder-CustomerEmpty-Popup-root-container">

                    <div className="MakeOrder-CustomerEmpty-Popup-root-container-child card">
                        <h4>Quantity is empty</h4>
                        <div>
                            Quantity of some items are not correctly entered. Either delete that item or enter quantity correctly.
                        </div>
                        <div className="MakeOrder-CustomerEmpty-Popup-child-button-container mt-4">
                            <button onClick={showHideQuantityIsEmptyPopup}>OK</button>

                        </div>
                    </div>
                </div>
            }
            {
                itemCodeIsEmptyPopup &&
                <div className="MakeOrder-CustomerEmpty-Popup-root-container">

                    <div className="MakeOrder-CustomerEmpty-Popup-root-container-child card">
                        <h4>Item not selected from the search list</h4>
                        <div>
                            Enter item name in search box and select an item from the result list
                        </div>
                        <div className="MakeOrder-CustomerEmpty-Popup-child-button-container mt-4">
                            <button onClick={showHideItemCodeIsEmptyPopup}>OK</button>

                        </div>
                    </div>
                </div>
            }

            {showBarcodeScannerView &&

                <OurBarcodeComponent
                    toggleBarcodeScannerView={toggleBarcodeScannerView}
                    resultGotAfterBarcodeScan={resultGotAfterBarcodeScan} />

            }


        </div>
    )

}

export default MakeOrderPage;